export default "__VITE_ASSET__DrHl2JMn__"